















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import FontAwesomeIcon from "@/components/FontAwesomeIcon.vue";
@Component({ components: { FontAwesomeIcon } })
export default class SuccessIcon extends Vue {
	@Prop({ type: String, default: "check" })
	customIcon!: string;

	@Prop({ type: String, default: "Success" })
	title!: string;
}
